import { render } from "./ProductDetail.vue?vue&type=template&id=625ad634&scoped=true&bindings={}"
import script from "./ProductDetail.vue?vue&type=script&lang=ts"
export * from "./ProductDetail.vue?vue&type=script&lang=ts"

import "./ProductDetail.vue?vue&type=style&index=0&id=625ad634&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-625ad634"

export default script